import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { apiClient } from '../../config/apiConfig';
import { log } from '../../utils/errors/logger';
import { ProviderType } from '../../components/dialogs/ShareFolderDialog/types';

/**
 * Custom hook for URL validation and file fetching
 * Handles provider detection and folder validation
 *
 * @returns Validation mutation and helper functions
 */
export const useShareFolderValidation = () => {
  const { t } = useTranslation();

  /**
   * Detect provider from URL
   */
  const detectProvider = (url: string): ProviderType => {
    if (url.includes('sharepoint.com')) {return 'sharepoint';}
    if (url.includes('onedrive.live.com') || url.includes('1drv.ms')) {return 'sharepoint';}
    return 'unknown';
  };

  /**
   * URL validation mutation
   */
  const validateUrl = useMutation({
    mutationFn: async (data: { url: string; password?: string }) => {
      log.api.request('POST', '/api/folder-syncs/validate-url', { data });
      const response = await apiClient.validateFolderUrl(data);
      log.api.response('POST', '/api/folder-syncs/validate-url', 200, {
        isValid: response.data.is_valid,
        provider: response.data.provider
      });
      return response.data;
    },
    onError: (error) => {
      log.api.error('POST', '/api/folder-syncs/validate-url', error as Error);
    },
  });

  return {
    validateUrl,
    detectProvider,
    isValidating: validateUrl.isPending,
    validationError: validateUrl.error,
  };
};
